import _implicitStylesheets from "./confirm.css";
import _implicitScopedStylesheets from "./confirm.scoped.css?scoped=true";
import _axButton from "ax/button";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="text-area${0}"${2}><div grid axis="column" row-gap="large" class="confirm-text-wrapper${0}"${2}><span${"a2:id"}${3}>${"t3"}</span></div></div>`;
const stc0 = {
  "confirm-modal": true
};
const stc1 = {
  slotAssignment: "main-content",
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "large"
  },
  key: 1
};
const stc2 = {
  slotAssignment: "footer",
  key: 4
};
const stc3 = {
  "data-testid": "cancel-button"
};
const stc4 = {
  "data-testid": "confirm-button"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [$cmp.showConfirm ? api_custom_element("wds-modal", _wdsModal, {
    classMap: stc0,
    props: {
      "title": $cmp.confirmState.confirmTitle
    },
    key: 0,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.cancel))
    }
  }, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(2, {
    attrs: {
      "id": api_scoped_id("confirm-text")
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.confirmState.confirmText))])]), api_element("div", stc2, [api_custom_element("ax-button", _axButton, {
    attrs: stc3,
    props: {
      "text": $cmp.confirmState.cancelButtonLabel,
      "variant": "tertiary"
    },
    key: 5,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.cancel))
    }
  }), api_custom_element("ax-button", _axButton, {
    attrs: stc4,
    props: {
      "text": $cmp.confirmState.confirmButtonLabel,
      "variant": "secondary",
      "theme": "error"
    },
    key: 6,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.confirm))
    }
  })])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4r99t4rmebh";
tmpl.legacyStylesheetToken = "undefined-_confirm";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
